export default "__VITE_ASSET__CgsATvza__"